<template>
  <div class="w-full h-full overflow-y-auto relative">
    <div class="lg:p-4 w-full flex justify-center h-full absolute">
      <div class="max-w-7xl grow">
        <h1
          class="mb-1 lg:mb-3 text-lg md:text-xl lg:text-2xl font-bold ml-2 mt-4 lg:mt-0 bg-white w-fit px-3 py-1 rounded-2xl text-primary-color"
        >
          {{
            userCourses.length > 0
              ? 'Programe active'
              : 'Nu exista momentan nici un program activ'
          }}
        </h1>
        <div
          class="grid grid-cols-[repeat(auto-fit,minmax(270px,1fr))] gap-4 lg:gap-8 p-2 justify-center place-items-center"
        >
          <Link
            v-for="course in userCourses"
            :key="course.id"
            :href="$routes.user_course(course.id)"
            class="bg-white w-full flex flex-col shadow-md h-full rounded-lg max-w-[400px] self-center"
          >
            <div class="w-full h-38 pt-1">
              <img
                v-if="course.image"
                :src="course.image"
                alt="Photo"
                class="block w-full h-full object-scale-down"
              />
            </div>
            <div class="self-center pt-2">
              <CourseTypeTag :type="course.type" />
            </div>
            <div class="flex flex-col justify-center grow">
              <div class="px-3 py-2 text-lg/6 font-semibold">
                {{ course.name }}
              </div>
              <div
                v-if="course.completion || course.completion === 0"
                class="flex flex-col pt-1 pb-3 px-3"
              >
                <div class="pb-1">
                  <ProgressBar
                    class="grow h-2"
                    :value="course.completion"
                    :show-value="false"
                    pt:value:class="bg-secondary-color"
                  />
                </div>
                <span
                  class="ml-5 text-secondary-color font-semibold text-sm self-end"
                  >{{ course.completion + '% complete' }}</span
                >
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Main.vue';
import { Link } from '@inertiajs/vue3';
import ProgressBar from 'primevue/progressbar';
import CourseTypeTag from '@/Shared/CourseTypeTag.vue';

export default {
  components: {
    Link,
    ProgressBar,
    CourseTypeTag,
  },
  layout: Layout,
  props: {
    userCourses: {
      type: Array,
      required: true,
    },
  },
};
</script>
